import React from 'react'
import { IHeaderParams } from 'ag-grid-community'
import styled from '@emotion/styled'
import { TextButton, TextButtonType } from 'view/components/buttons'
import * as constants from 'view/styles/constants'
import { Locale, Translation } from 'locale'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import { SalesCoverageDialog } from './SalesCoverageDialog'

interface SalesCoverageHeaderRendererProps extends IHeaderParams, ModalConsumerProps {}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  color: ${constants.CORE_PRIMARY_6};
`

export class SalesCoverageHeaderRendererComponent extends React.Component<SalesCoverageHeaderRendererProps> {
  private handleClick = () => {
    const { api, showModal } = this.props
    showModal(<SalesCoverageDialog tradingEntityMetaDetails={api.getSelectedRows()} />)
  }

  render() {
    const { api, column } = this.props

    const items = api.getSelectedRows()

    return (
      <Container>
        {column.getColDef().headerName}
        {items.length > 0 && (
          <TextButton type={TextButtonType.Tertiary} onClick={this.handleClick}>
            {Locale.translate(Translation.TC_ACTION_BULK_APPLY)}
          </TextButton>
        )}
      </Container>
    )
  }
}

export const SalesCoverageHeaderRenderer = withModal(SalesCoverageHeaderRendererComponent)
